var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M0,0V15H25V0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-en",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag-en-2",
    "data-name": "flag-en",
    transform: "translate(-0.835 -1.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M0,0V15H25V0Z",
    transform: "translate(0.835 1.341)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16272",
    "data-name": "Path 16272",
    d: "M7422.061,23050.52l-11.941,7.166L7409,23055l10.264-6.156-10.264-6.16,1.117-2.682,11.941,7.164L7434,23040l1.12,2.682-10.265,6.16,10.265,6.156-1.12,2.686Z",
    transform: "translate(-7408.726 -23040.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16273",
    "data-name": "Path 16273",
    d: "M7409.894,23056.789h0l12.5-7.5v1.119l-10.636,6.379Zm12.5-7.5v-1.119l10.636-6.383h1.864l-12.5,7.5h1.862l10.638,6.381v1.117ZM7422.394,23049.291ZM7422.394,23049.291Zm-1.865,0-10.636-6.385v-1.117l12.5,7.5ZM7422.394,23049.291Z",
    transform: "translate(-7409.059 -23040.449)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16271",
    "data-name": "Path 16271",
    d: "M7420.249,23055v-6H7409v-3h11.252v-6h2.5v6H7434v3h-11.251v6Z",
    transform: "translate(-7408.164 -23038.66)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16271_-_Outline",
    "data-name": "Path 16271 - Outline",
    d: "M7421.581,23054v-6h11.251v-3h-11.251v-6h-2.5v6H7407.83v3h11.252v6h2.5m.833,1h-4.166v-6H7407v-5h11.251v-6h4.166v6h11.252v5h-11.252Z",
    transform: "translate(-7406.997 -23037.66)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.9c27435e327096ffe3923927a0958c08.svg";
export { ForwardRef as ReactComponent };